import { ReactNode } from 'react';

export const getValueOrNA =
  (field?: string) =>
  ({ data }: { data?: Record<string, unknown> }): ReactNode => {
    const value = field ? data?.[field] : undefined;

    if (value === null || value === undefined || value === '') {
      return 'N/A';
    }

    if (typeof value === 'object') {
      return 'N/A';
    }

    return value as string | number | boolean;
  };
